function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4002 12.3773C13.7627 12.7485 13.7627 13.3504 13.4002 13.7216C13.0377 14.0928 12.4499 14.0928 12.0874 13.7216L7 8.5122L1.91263 13.7216C1.5501 14.0928 0.962327 14.0928 0.599798 13.7216C0.23727 13.3504 0.23727 12.7485 0.599798 12.3773L5.68717 7.16788L0.271896 1.62273C-0.0906319 1.25151 -0.0906322 0.64964 0.271896 0.278417C0.634425 -0.0928059 1.2222 -0.0928055 1.58473 0.278417L7 5.82357L12.4153 0.278417C12.7778 -0.0928053 13.3656 -0.0928059 13.7281 0.278417C14.0906 0.64964 14.0906 1.25151 13.7281 1.62273L8.31283 7.16788L13.4002 12.3773Z",
  fill: "#131313"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.c62b2c12.svg";
export { ForwardRef as ReactComponent };